import { ClientSelection, ClientType } from '../types/users';
import { toBooleanFlag } from './featureFlags';

/**
 * Campos del doc `clients/{id}` de Firestore que hacen falta para armar la selección.
 * Lo cumplen tanto `Client` (ClientSelector, con `id`) como los objetos del panel de
 * System Admin (ClientCard / ClientAdminPage, con `uid`): por eso el id va aparte.
 */
export interface ClientSelectionSource {
  name: string;
  logo?: string;
  logoHeight?: number;
  client_type?: string;
  welcomeVideo?: string;
  enable_tags?: unknown;
  enable_sku?: unknown;
}

/**
 * Arma el objeto que va a `setSelectedClient` (PT-#87, fix "Ir a cliente").
 *
 * Única fuente para todos los puntos de entrada a un cliente. Antes, el botón "Ir a cliente"
 * de System Admin armaba la selección sin `enable_tags`/`enable_sku`, y como los consumidores
 * chequean `selectedClient?.enable_tags !== false`, `undefined` contaba como "usa tags":
 * Adidas (enable_tags=false) terminaba leyendo marcas de la tabla `tags` congelada.
 *
 * Defaults iguales a ClientContext: tags ON salvo que el doc diga lo contrario, SKU OFF.
 */
export const buildClientSelection = (
  clientId: string,
  client: ClientSelectionSource
): ClientSelection => ({
  clientId,
  clientName: client.name,
  clientLogo: client.logo,
  clientLogoHeight: client.logoHeight,
  clientType: client.client_type as ClientType | undefined,
  clientWelcomeVideo: client.welcomeVideo,
  enable_tags: toBooleanFlag(client.enable_tags, true),
  enable_sku: toBooleanFlag(client.enable_sku, false),
});
